import React, { useEffect, useState } from 'react'
import useReactApexChart from '../../hook/useReactApexChart'
import { getdashboard } from '../../Api'

const UnitCountThree = () => {
    let { createChartThree } = useReactApexChart()
    const [userStocks, setUserStocks] = useState([])

    const CRYPTO_COLORS = [
        '#F98C08', // BTC
        '#5F80FF', // ETH
        '#C817F8', // SOL
        '#2171EA', // LTE
        '#C2A633'  // DOGE
        ];

    useEffect(() => {
        getdashboard().then((res) => {
            console.log(res);
            if (res.code === 200) {
                console.log(res.userstocks);
                setUserStocks(res.userstocks)
            } else {
                setUserStocks([])
                console.error("Error fetching dashboard data:");
            }
        } ).catch((error) => {
            setUserStocks([])
            console.error("Error fetching dashboard data:", error);
        }); 
    }, [])

    return (
        <div className=" row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
            {userStocks.map((stock, idx) => ( 
                <div className="col" key={stock.id || idx}>
                <div className="card shadow-none border bg-gradient-end-3">
                <div className="card-body p-20">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                       
                        <div className="flex-grow-1">
                            <h6 className="text-xl mb-1">{stock.stock_name}</h6>
                        </div>
                    </div>
                    <div className="mt-3 d-flex flex-wrap justify-content-between align-items-center gap-1">
                        <div className="">
                            <h6 className="mb-8">{stock.currency} {stock.price} </h6>
                        </div>
                        <div
                            id="bitcoinAreaChart"
                            className="remove-tooltip-title rounded-tooltip-value"
                        >
                            {/* Pass the color value here */}
                            {createChartThree(CRYPTO_COLORS[idx] , stock.singlestock_data)}
                        </div>
                    </div>
                </div>
                </div>
                </div>
            ))}
            
        </div>

    )
}

export default UnitCountThree